/**
 * @file ドロップダウンメニューの表示・非表示
 *
 */
'use strict';

/**
 * @classname DropdownMenuView
 * @classdesc ドロップダウンメニューの表示・非表示
 */
export default class DropdownMenuView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('DropdownMenuView.hover');
		this._$e = $e;
		// this._$gnavpc = $('.header__gnav--pc li');
		this._$dropdown = this._$e.find('.dropdown');
		this._$e.on('mouseover', () => this.onHover());
		this._$dropdown.on('mouseout', () => this.offHover());
		$('main').on('mouseout', () => this.offHover());
	}

	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof DropdownMenuView
	 * @return {undefined}
	 */
	onHover() {
		console.log('DropdownMenuView.onHover');
		$('.dropdown').removeClass('open');
		this._$dropdown.addClass('open');
	}
	offHover() {
		//console.log('DropdownMenuView.offHover');
		this._$dropdown.removeClass('open');
	}
}
